import orderTranslationsHelper from "../../../../../languages/order-translations.helper";
import {
  OrderCancelOrderCancelledError,
  OrderCancelOrderErrorType,
  OrderCancelOrderPassengerOnboardError,
} from "./order-cancel-order-error";

const createOrderCancelError = (): OrderCancelOrderCancelledError => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().cancelOrder.errors;

  return {
    message: translations.orderCancelledError,
    params: {},
    type: OrderCancelOrderErrorType.ORDER_CANCELLED,
  };
};

const createPassengerOnBoardError =
  (): OrderCancelOrderPassengerOnboardError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().cancelOrder.errors;

    return {
      message: translations.passengerOnBoardError,
      params: {},
      type: OrderCancelOrderErrorType.PASSENGER_ON_BOARD,
    };
  };

const OrderCancelOrderErrorFactory = {
  createOrderCancelError,
  createPassengerOnBoardError,
};

export default OrderCancelOrderErrorFactory;
